"use client";

import { Button } from "@/components/ui/button";
import { useScrollToTop } from "@/hooks/use-scroll-to-top";
import { cn } from "@/lib/utils";
import { ArrowUp } from "lucide-react";

interface ScrollToTopProps {
	threshold?: number;
	className?: string;
}

export function ScrollToTop({ threshold = 300, className }: ScrollToTopProps) {
	const { isVisible, scrollToTop } = useScrollToTop(threshold);

	return (
		<Button
			variant="outline"
			size="icon"
			onClick={scrollToTop}
			aria-label="Scroll to top"
			className={cn(
				"fixed bottom-6 right-6 z-50 rounded-full",
				"shadow-sm transition-all duration-200",
				"bg-transparent backdrop-blur-sm backdrop-saturate-150 shadow-lg border-4 border-primary/50",
				isVisible
					? "opacity-100 translate-y-0"
					: "opacity-0 translate-y-2 pointer-events-none",
				className,
			)}
		>
			<ArrowUp className="h-6 w-6" />
		</Button>
	);
}
